import http from './request'

// 分页获取下级信息
export const getFriendInfoPagedList = (data) => {
  return http({
    url: '/promotion/ActivityAgent/getFriendInfoPagedList',
    method: 'post',
    data
  })
}

// 获取下级任务记录列表
export const getFriendTaskRecordList = (data) => {
  return http({
    url: '/promotion/ActivityAgent/getFriendTaskRecordList',
    method: 'post',
    data
  })
}

// 获取用户信息
export const getUserInfoInAgent = (data) => {
  return http({
    url: '/promotion/ActivityAgent/getInfo',
    method: 'post',
    data
  })
}

// 获取任务列表
export const getAgentTaskList = (data) => {
  return http({
    url: '/promotion/ActivityAgent/listTask',
    method: 'post',
    data
  })
}
